import clsx from 'clsx'
import React from 'react'
import { AppMode } from '@customTypes/Generic'
import { ReactComponent as BackIcon } from 'src/images/icon-back.svg'
import { ReactComponent as CloseIcon } from 'src/images/icon-close-v2.svg'
import logToPostHog from 'src/helpers/logToPosthog'
import { useConfig } from '@context/ConfigurationContext'
import { useCloseAvailyContext } from '@context/CloseAvailyContext'
import useStyles from './Header.styles'
import { TEST_IDS } from 'src/constants/testIds'
import { StatusBarDesktop } from '../StatusBar/StatusBarDesktop'
import { StatusBarMobile } from '../StatusBar/StatusBarMobile'
import AnimatedSteps from '@components/AnimatedSteps/AnimatedSteps'
import { useIsDesktopDown } from 'src/config/mediaQueries'
import { useStepsState } from '@context/StepsContext'

export type HeaderProps = {
  desktopHeadingText?: string
  mobileHeadingText?: string
  mobileSubheadingText?: string
  treatmentTitle?: string
  onBackClick?: () => void
  hideStatusBar?: boolean
  postHogAction?: string
  hideEmptyHeadingSpacing?: boolean
}

const Header = ({
  desktopHeadingText,
  hideEmptyHeadingSpacing,
  mobileHeadingText,
  mobileSubheadingText,
  onBackClick,
  hideStatusBar = false,
  postHogAction,
}: HeaderProps) => {
  const classes = useStyles()
  const { mode, asModal } = useConfig()
  const closeAvaily = useCloseAvailyContext()
  const isDesktopDown = useIsDesktopDown()

  const { step: currentStep = 0, totalSteps } = useStepsState()
  const shouldShowStatusBar = !hideStatusBar && mode === AppMode.NORMAL

  const headingTitle = (
    <>
      <div
        className={clsx(classes.headingText, {
          [classes.emptyHeadingText]: !desktopHeadingText,
          [classes.titleInsteadOfProgressBar]: !shouldShowStatusBar,
          [classes.emptyHeadingTextNoSpacing]: hideEmptyHeadingSpacing,
        })}
      >
        {desktopHeadingText}
      </div>
      <div
        className={clsx(classes.headingText, classes.mobileHeadingText, {
          [classes.emptyMobileHeadingText]: !mobileHeadingText,
          [classes.titleInsteadOfProgressBar]: !shouldShowStatusBar,
        })}
      >
        {mobileHeadingText}
      </div>
    </>
  )

  const closeModal = () => {
    postHogAction && logToPostHog(postHogAction)
    closeAvaily && closeAvaily()
  }

  return (
    <>
      <div className={classes.header}>
        <div className={classes.iconCont} onClick={onBackClick && onBackClick}>
          {onBackClick && <BackIcon data-test={TEST_IDS.buttonBack} />}
        </div>
        <div className={classes.headingsCont}>
          {shouldShowStatusBar ? (
            <>
              <StatusBarDesktop />
              <StatusBarMobile />
            </>
          ) : (
            headingTitle
          )}
        </div>
        <div className={classes.iconCont}>{asModal && closeAvaily && <CloseIcon onClick={closeModal} />}</div>
      </div>
      {shouldShowStatusBar && isDesktopDown && <AnimatedSteps currentStep={currentStep} totalSteps={totalSteps} />}
      {shouldShowStatusBar && headingTitle}
      {mobileSubheadingText && <div className={classes.mobileSubheading}>{mobileSubheadingText}</div>}
    </>
  )
}

export default Header
